import './App.css';
import Portfolio from './Portfolio.tsx';

function App() {
  return (
    <div className="App">
      <Portfolio />
    </div>
  );
}

export default App;
